<div
  class="gd-form-input-v2">

  <!-- Input data -->
  <mat-form-field
    *ngIf="!viewOnly; else viewOnlyTemplate"
    appearance="outline">

    <!-- Place holder -->
    <mat-label
      *ngIf="!neverFloatLabel">
      {{ placeholder | translate }}
    </mat-label>

    <!-- Left - Icon buttons -->
    <ng-container
      *ngIf="tooltipButton?.tooltip"
      matPrefix>
      <popper-content
        #popperContent>
        <div
          [innerHtml]="tooltipButton.tooltip | safeHtml">
        </div>
      </popper-content>
      <mat-icon
        tabindex="-1"
        [popper]="popperContent"
        popperTrigger="hover"
        popperApplyClass="gd-form-input-v2-tooltip"
        popperPreventOverflow="true"
        popperPositionFixed="true"
        popperAppendTo="body"
        (click)="$event.stopPropagation()">{{tooltipButton.icon}}</mat-icon>
    </ng-container>

    <!-- Input -->
    <input
      matInput
      [(ngModel)]="value"
      (blur)="onTouchItem()"
      [errorStateMatcher]="errMatcher"
      [disabled]="disabled"
      [required]="required"
      [placeholder]="neverFloatLabel ? (placeholder | translate) : undefined"
      [autocomplete]="autocomplete"
      name="{{name}}">

    <!-- Spinner -->
    <mat-progress-spinner
      *ngIf="control?.pending"
      matSuffix
      diameter="16"
      mode="indeterminate"
      color="primary">
    </mat-progress-spinner>

    <!-- Right - Icon buttons -->
    <ng-container
      *ngFor="let iconB of suffixIconButtons"
      matSuffix>
      <span
        *ngIf="!iconB.visible || iconB.visible(this)"
        (click)="$event.stopPropagation()">
        <button
          tabindex="-1"
          type="button"
          mat-icon-button
          [matTooltip]="iconB.tooltip | translate"
          [disabled]="iconB.disabled && iconB.disabled(this)"
          (click)="iconB.clickAction ? iconB.clickAction(this) : undefined"><mat-icon>{{iconB.icon}}</mat-icon></button>
      </span>
    </ng-container>

    <!-- Errors -->
    <mat-error
      *ngIf="control?.invalid && control?.touched">
      {{ getErrorMessages() }}
    </mat-error>

  </mat-form-field>

  <!-- View only -->
  <ng-template
    #viewOnlyTemplate>
    <div
      fxLayout="row" fxLayoutGap="1.6rem"
      class="gd-form-input-v2-viewonly">
      <!-- Label -->
      <div
        *ngIf="placeholder"
        class="gd-form-input-v2-viewonly-label">
        {{ placeholder | translate }}:
      </div>

      <!-- Value -->
      <div
        class="gd-form-input-v2-viewonly-value">
        {{value ? value : noValueLabel}}
      </div>
    </div>
  </ng-template>
</div>
